import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=5c2cbf62&scoped=true&"
import script from "./Introduce.vue?vue&type=script&lang=js&"
export * from "./Introduce.vue?vue&type=script&lang=js&"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=5c2cbf62&scoped=true&lang=less&"
import style1 from "./Introduce.vue?vue&type=style&index=1&id=5c2cbf62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2cbf62",
  null
  
)

export default component.exports